import script from "./newCommonTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./newCommonTable.vue?vue&type=script&setup=true&lang=ts"

import "./newCommonTable.vue?vue&type=style&index=0&id=11d5ade8&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d5ade8"]])

export default __exports__